// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1HYEM","title":"Info_title__3o_FN","links":"Info_links__3rm0I","link":"Info_link__3ZZni","logo":"Info_logo__1ZG7l"};